<template>
  <v-col cols="3" v-if="chatEnabled">
    <v-card class="align-start metrics-card-middle-bottom">
      <v-card-title class="d-flex justify-space-between">
        <div class="hidden-element">Hidden</div>
        <!--Hidden element to allow center and right align of label and icon-->
        <label class="font-weight-bold text-decoration-underline">Bot Results</label>
        <tooltip>
          <p>Chat Leads = Live chat leads via agents</p>
          <p>Form Fill Leads = Leads via forms only, excluding live chat leads</p>
        </tooltip>
      </v-card-title>
      <v-card-text class="d-flex justify-space-around metrics-card-text">
        <StatsValue :loading="loading" title="Chat leads">{{ chatLeadsCount }}</StatsValue>
        <StatsValue :loading="loading" title="Form fill leads">{{ formFillLeadsCount }}</StatsValue>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import {mapState} from 'vuex';
import {LoadingState} from '@/store/constants';
import StatsValue from '@/components/HealthScore/StatsValue.vue';
import Tooltip from '@/components/HealthScore/Tooltip.vue';

export default {
  name: 'BotResults',
  components: {Tooltip, StatsValue},
  computed: {
    ...mapState('healthScoreStore', ['chatLeads', 'chatEnabled']),
    loading() {
      return this.chatLeads.state === LoadingState.LOADING;
    },
    chatLeadsCount() {
      const liveChatLeads = this.chatLeads.data.find(element => element.source === 'chat');
      return liveChatLeads ? liveChatLeads.count : 0;
    },
    formFillLeadsCount() {
      const formFillLeads = this.chatLeads.data.find(element => element.source === 'chat form');
      return formFillLeads ? formFillLeads.count : 0;
    },
  },
};
</script>
